/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";

// Files Import
import StyledMdText from "../../common/components/styledMdText/StyledMdText";
import StyledH4Heading from "../../common/components/styledH4Heading/StyledH4Heading";

const CountdownTimer = ({ launchdate }) => {
  const [timerParts, setTimerPorts] = useState([
    {
      value: 0,
      label: "Days",
    },
    {
      value: 0,
      label: "Hours",
    },
    {
      value: 0,
      label: "Min",
    },
    {
      value: 0,
      label: "Sec",
    },
  ]);

  function formatTime(time) {
    if (time) {
      const days = Math.floor(time / (3600 * 24))
        .toString()
        .padStart(2, "0");
      const hours = Math.floor((time % (3600 * 24)) / 3600)
        .toString()
        .padStart(2, "0");
      const minutes = Math.floor((time % 3600) / 60)
        .toString()
        .padStart(2, "0");
      const seconds = (time % 60).toString().padStart(2, "0");
      return [
        { value: days, label: "Days" },
        { value: hours, label: "Hours" },
        { value: minutes, label: "Min" },
        { value: seconds, label: "Sec" },
      ];
    } 
  }

  useEffect(() => {
    if (!launchdate) return;
    const launchTime = new Date(launchdate).getTime();
    const currentTime = new Date().getTime();
    const totalTime = Math.floor((launchTime - currentTime) / 1000);
    if (totalTime <= 0) {
      setTimerPorts(formatTime(0));
      return;
    }
    localStorage.setItem("startTime", currentTime.toString());
    const intervalId = setInterval(() => {
      const updatedTime = new Date().getTime();
      const elapsedSeconds = Math.floor((updatedTime - currentTime) / 1000);
      const remaining = totalTime - elapsedSeconds;

      if (remaining >= 0) {
        setTimerPorts(formatTime(remaining));
      } else {
        clearInterval(intervalId);
      }
    }, 1000);

    return () => clearInterval(intervalId);
  }, [timerParts]);


  return (
    <div className="flex items-center justify-center">
      {timerParts?.map((part, index) => (
        <div key={index} className="text-center justify-between w-full">
          <motion.div
            initial={{ scale: 1 }}
            animate={{ scale: 1 }}
            transition={{ duration: 0.5 }}
            className="flex items-center justify-between"
          >
            <motion.div
              key={part.value}
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{ duration: 0.5 }}
              className="w-full"
            >
              <StyledH4Heading>{part.value}</StyledH4Heading>
            </motion.div>
            {index < 3 && <hr className="w-[1px] h-12 bg-white opacity-20" />}
          </motion.div>
          <StyledMdText>{part.label}</StyledMdText>
        </div>
      ))}
    </div>
  );
};

export default CountdownTimer;
